import { useCallback, useMemo, useState } from 'react';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import useFetchCrmObjectProperties from 'framework-asset-preview-lib/internal/shared/hooks/useFetchCrmObjectProperties';
import useAssetPreviewTracking from 'framework-asset-preview-lib/internal/shared/hooks/useAssetPreviewTracking';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import AssociatedAssets from './AssociatedAssets';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AssociationGroupWithFetchedObjects({
  associationGroup,
  crmObject,
  defaultOpen,
  hoverAssetId,
  onHoverAsset
}) {
  const [open, setOpen] = useState(defaultOpen);
  const {
    trackAssetPreviewInteraction
  } = useAssetPreviewTracking();
  const {
    properties,
    error: errorProperties,
    loading: loadingProperties
  } = useFetchCrmObjectProperties(associationGroup.toObjectTypeId, {
    skip: !open || associationGroup.toObjectTypeId === OBJECT_TYPE.TRACKING_URL
  });
  const handleOpenChange = useCallback(event => {
    const isOpen = Boolean(event.target.value);
    setOpen(event.target.value);
    trackAssetPreviewInteraction({
      action: isOpen ? 'expand association group' : 'expand association group'
    });
  }, [trackAssetPreviewInteraction]);
  const isLoading = useMemo(() => loadingProperties, [loadingProperties]);
  const isError = useMemo(() => !isLoading && Boolean(errorProperties), [errorProperties, isLoading]);
  const isEmptyState = useMemo(() => Boolean(!isLoading && !isError && associationGroup.associatedObjects && associationGroup.associatedObjects.length === 0), [associationGroup.associatedObjects, isError, isLoading]);
  return /*#__PURE__*/_jsx(ExpandableSection, {
    indentation: "compact",
    titleText: associationGroup.objectTypeName,
    open: open,
    onOpenChange: handleOpenChange,
    children: /*#__PURE__*/_jsx(AssociatedAssets, {
      associatedObjects: associationGroup.associatedObjects || [],
      associationGroup: associationGroup,
      crmObject: crmObject,
      hoverAssetId: hoverAssetId,
      isEmptyState: isEmptyState,
      isError: isError,
      isLoading: isLoading,
      onHoverAsset: onHoverAsset,
      properties: properties
    })
  });
}